import { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client/react";

import { NotificationDetailPage as Component } from "../../../components/pages/notification/NotificationDetailPage";
import { GET_CS_NOTIFICATION } from "../../../graphql/queries";
import { PREVIEW_CS_NOTIFICATION_MARKDOWN } from "../../../graphql/queries";
import { DELETE_CS_NOTIFICATION } from "../../../graphql/mutations";
import { useCheckUserRole } from "../../../hooks/useCheckUserRole";
import { showSnackBar } from "../../../graphql/local-mutations";

export const NotificationDetailPage = () => {
  useCheckUserRole();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const { data, loading } = useQuery(GET_CS_NOTIFICATION, {
    variables: { id },
    skip: !id,
  });

  const [fetchPreview, { data: previewData }] = useLazyQuery(
    PREVIEW_CS_NOTIFICATION_MARKDOWN,
    { fetchPolicy: "network-only" },
  );

  const [deleteNotification] = useMutation(DELETE_CS_NOTIFICATION);

  const notification = data?.csNotification;

  // 通知データ取得後にMarkdownプレビューを取得
  useEffect(() => {
    if (notification?.body) {
      fetchPreview({ variables: { body: notification.body } });
    }
  }, [notification?.body, fetchPreview]);

  const handleDelete = useCallback(async () => {
    if (!id || !window.confirm("このお知らせを削除しますか？")) return;
    try {
      const { data: result } = await deleteNotification({
        variables: { id },
      });
      const payload = result?.deleteCsNotification;
      if (payload?.__typename === "DeleteCsNotificationError") {
        showSnackBar(payload.message);
        return;
      }
      showSnackBar("お知らせを削除しました");
      navigate("/notifications");
    } catch {
      showSnackBar("お知らせの削除に失敗しました");
    }
  }, [id, deleteNotification, navigate]);

  return (
    <Component
      loading={loading || !notification}
      notification={notification ?? null}
      previewHtml={previewData?.previewCsNotificationMarkdown ?? ""}
      onEditClick={() => navigate(`/notifications/${id}/edit`)}
      onDeleteClick={handleDelete}
    />
  );
};
